import { BaseLayoutFactory } from "../global/base-layout-factory";
import { ManagedUnitProvider } from "./context/managed-unit-context";
import { ManagedUnitComponent } from "./managed-unit-component";

export function ManagedUnitFactory() {
    return (
        <BaseLayoutFactory>
            <ManagedUnitProvider>
                <ManagedUnitComponent />
            </ManagedUnitProvider>
        </BaseLayoutFactory>
    );
}